<template>
	<div class="question">
	
		
		<div class="index-conent-left-connet1">
			<div class="list-div" v-for="(item,index) in list" :key="index">
				<div class="list-div-titleh2">
					<div>{{item.question.name}}</div>
					<div>ID：{{item.question.id}}</div>
				</div>
			
				<img class="imgs"  :src="item.question.img" />
				<div class="list-div-bao1">
					<div>难易度</div>
					<div>
						<img v-if="item.question.difficulty>=1" src="../../assets/shudo/images/11.svg" />
						<img v-if="item.question.difficulty>=2" src="../../assets/shudo/images/11.svg" />
						<img v-if="item.question.difficulty>=3" src="../../assets/shudo/images/11.svg" />
						<img v-if="item.question.difficulty>=4" src="../../assets/shudo/images/11.svg" />
						<img v-if="item.question.difficulty>=5" src="../../assets/shudo/images/11.svg" />
					
						
					</div>
				</div>
				<div class="list-div-top1">
					<div style="flex: 3;">
						<!-- <img :src="item.classify.avatar" /> -->
						<!-- <div>{{item.classify.username}}</div> -->
					</div>
					<div>
					<!-- 	<img src="../../assets/shudo/images/10.svg" />
						<div>20</div> -->
					</div>
				</div>
			</div>
			
			
			
		</div>
	</div>
	
</template>

<script>
	export default {
		data() {
			return {
				tab: 0,
				img_png_action :0,
				hide :  0,
				use_id : '',
				count : 0,
				list : []
			}
		},
		created() {
			let that  = this;
			var  query = that.$route.query;
			that.user_id = query.user_id;
			that.$http('get','/api/v1/questionmy/list',{user_id:that.user_id}) .then(function (res) {
				that.list  = res.data.list;
				// that.count = res.data.list.length;
			});	
			
		},
		methods:{
			tabClick(e){
				this.tab = e;
			},
			img_png_actionClick(e){
				this.img_png_action = e;
			},
			

		},
	}
</script>

<style lang="less">
	.question {
		width: 100%;
		min-height: 25rem;
		color: #7F7F7F;
		.title {
			width: 92%;
			margin: auto;
			border-bottom:1px solid #a29e9eb5;
			line-height: 2rem;
			height: 2rem;
			display: flex;
			div {
				padding-left: 0.2rem;
				width:5.6rem;
				text-align: center;
				height: 2rem;
			}
			.tabcolor {
				border-bottom:2px solid #d63030;
			}
		}
		.index-conent-left-connet1{
			min-height: 14rem;
			display: flex;
			margin-top: 1rem;
			flex-wrap: wrap;
			.list-div {
				border-radius: 0.4rem;
				min-height: 9.5rem;
				background-color: #FFFFFF;
				margin-left: 1rem;
				margin-right: 1rem;
				margin-top: 0.6rem;
				margin-bottom: 0.6rem;
				width: 10rem;
				font-size: 0.5rem;
				img {
					display: block;
					margin: auto;
					width: 90%;
				}
				.img_png {
					margin-left: 0.5rem;
					background-color: rgba(9, 7, 35, 0.788235294117647);
					width: 9rem;
					position: absolute;
					bottom: 6.2rem;
					height: 9rem;
					div {
						margin-top: 0.6rem;
						width: 100%;
						height: 2.2rem;
						img {
							padding-top: 0.1rem;
							width: 1.8rem;
						}
					}
					.img_png_action {
						background-color: rgba(9, 7, 35, 0.807843137254902);
					}
				}
				.list-div-titleh2 {
					height: 1.5rem;
					padding-left: 0.6rem;
					line-height: 1.5rem;
					font-size: 0.2rem;
					display: flex;
					div:nth-last-child(1){
						margin-left: auto;
						padding-right: 0.3rem;
						color: #878787;
					}
				}
				.list-div-title {
					padding-top: 0.3rem;
					padding-left: 0.6rem;
					display:flex;
					img {
						width: 22px;
						margin-left: 0;
					}
					div:nth-last-child(2){
						line-height: 2rem;
						flex:1;
						padding-left: 0.2rem;
						color: #181818c4;
					}
					div:nth-last-child(1){
						line-height: 2rem;
						flex:1;
						font-size: 0.5rem;
					}
				}
				.list-div-bao {
					padding-top: 0.1rem;
					padding-left: 0.6rem;
					color: #181818c4;
					font-size: 0.3rem;
				}
				.list-div-bao1{
					padding-top: 0.1rem;
					padding-left: 0.6rem;
					color: #181818c4;
					font-size: 0.3rem;
					display: flex;
					div:nth-last-child(2){
						width: 30%;
					}
					div:nth-last-child(1){
						display: flex;
						
						img{
							width: 10px;
						}
					}
				}
				.list-div-top {
					padding-top: 0.1rem;
					line-height: 1.5rem;
					display: flex;
					height: 2rem;
					div:nth-last-child(2){
						padding-left: 0.6rem;
						font-size: 0.5rem;
						flex:3;
					}
					div:nth-last-child(1){
						flex: 1;
						color: #d9001b;
						text-align: right;
						padding-right: 4px;
						font-size: 0.8rem;
					}
				}
				.list-div-top1 {
					padding-top: 0.1rem;
					line-height: 1.5rem;
					display: flex;
					height: 2rem;
					div:nth-last-child(2){
						flex:1;
						display: flex;
						padding-left: 0.6rem;
						line-height: 2rem;
						img{
							width: 20px;
						}
						div {
							padding-left: 0.2rem;
						}
					}
					div:nth-last-child(1){
						flex:1;
						display: flex;
						margin-right: auto;
						line-height: 2rem;
						padding-left: 2.3rem;
						color: #d9001b;
						img{
							width: 16px;
						}
						div {
							padding-left: 0.2rem;
						}
						
					}
				}
			}
		}
		.imgs {
			height: 7.9rem;
		}
	}
</style>
